$(document).on('click', '*[data-password]', function (event) {
    var arr = $(this).attr('data-password');
    var target = arr.split(' ');
    for (var i = 0; i < target.length; i++) {
        var x = document.getElementById(target[i]);
        if (x.type === 'password') {
            x.type = 'text';
            $(this).addClass('visible');
        } else {
            x.type = 'password';
            $(this).removeClass('visible');
        }
    }
});

function setFieldState() {
    const field = $('.js-field-with-btn');
    const btn = $('.js-btn-field-clear');

    field.each(function () {
        if ($(this).val() == '') {
            $(this).siblings(btn).removeClass('active');
        } else {
            $(this).siblings(btn).addClass('active');
        }
    });
}

runIfElementExist(setFieldState, '.js-btn-field-clear');

$(document, '.mdl-wrap').on('input', '.js-field-with-btn', function () {
    setFieldState();
});

$(document, '.mdl-wrap').on('click', '.js-btn-field-clear', function () {
    $(this).siblings('.js-field-with-btn').val('').trigger('change');
    $(this).removeClass('active');
    $(this).siblings('.form-item').removeClass('error success');
    $(this)
        .closest('.form-item-wrap')
        .siblings('.js-field-sign')
        .removeClass('active');
});

$(document).on('input', '.js-login-field', function () {
    $(this)
        .removeClass('error')
        .closest('.form-item-wrap')
        .siblings('.js-form-item-sign')
        .removeClass('active');
});

/* field check num */
$(function () {
    if ($('input.js-num').length > 0) {
        $(document).on('change keyup input', 'input.js-num', function (event) {
            if (this.value.match(/[^0-9]/g)) {
                this.value = this.value.replace(/[^0-9]/g, '');
            }
        });
    }
});
/*  */

/* previous version  */
// Clear all form fields.
// function clearAllFormFields() {
//     const btn = $('.js-clear-form-btn');
//     const form = $(`#${btn.data('form')}`);
//     form.find($('.js-field-with-btn')).each(function () {
//         $(this).val('').removeClass('error');
//     });
//     form.find($('.js-btn-field-clear')).each(function () {
//         $(this).removeClass('active');
//     });
//     form.find($('.js-field-sign')).each(function () {
//         $(this).removeClass('active');
//     });
// }

function clearAllFormFields() {
    const btn = $('.js-clear-form-btn');
    const formIds = btn.data('form')?.split(/\s+/) || [];

    formIds.forEach((formId) => {
        const form = $(`#${formId}`);

        if (form.length === 0) {
            console.warn(`Form with id="${formId}" is not find`);
            return;
        }

        form.find('.js-field-with-btn').each(function () {
            $(this).val('').removeClass('error');
        });

        form.find('.js-btn-field-clear').each(function () {
            $(this).removeClass('active');
        });

        form.find('.js-field-sign').each(function () {
            $(this).removeClass('active');
        });
    });
}

$(document, '.mdl-wrap').on('click', '.js-clear-form-btn', function () {
    clearAllFormFields();
});
